module.exports = __webpack_public_path__ + "static/media/s1.90542471.png";